import { useState, useEffect } from "react"
import Button from "../ui/Button"
import Modal from "../ui/Modal"
import InvitationController from "@/network/controllers/invitation.controller"
import { useSession } from "@/hooks/useSession"
import { STATE, CurrentStudyState } from "@state"
import { useParams } from "react-router-dom"

export default function PatientsInvitationSection() {
  const { user } = useSession()
  const { studyId: urlStudyId } = useParams() 
  const currentStudyFromState = STATE[CurrentStudyState.STUDY] 
  const isClosed = (() => {
    const status = currentStudyFromState?.status || currentStudyFromState?.study_global_status || ""
    return String(status).toLowerCase() === "closed"
  })()

  try {
    console.log("[PatientInvitation] status derivation", {
      urlStudyId,
      studyIdFromState: STATE[CurrentStudyState.STUDY]?.id,
      status: currentStudyFromState?.status,
      study_global_status: currentStudyFromState?.study_global_status,
      derived_isClosed: isClosed,
    })
    console.log("[PatientInvitation] UI flags", {
      submit_disabled: isClosed,
    })
  } catch (_) {}

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street: "",
    number: "",
    country: "",
    city: "",
    postalCode: "",
    study_id: "",
    investigator_id: "",
    site_id: "",
  })

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)


  useEffect(() => {
    const newEffectiveStudyId = urlStudyId || STATE[CurrentStudyState.STUDY]?.id

    const newInvestigatorId = STATE[CurrentStudyState.STUDY]?.investigator_id
    const newEffectiveSiteId = STATE[CurrentStudyState.STUDY]?.site_id

    console.log("PatientsInvitationSection - useEffect triggered:")
    console.log("  urlStudyId (in effect):", urlStudyId)
    console.log("  STATE[CurrentStudyState.STUDY]?.id (in effect):", STATE[CurrentStudyState.STUDY]?.id)
    console.log("  newEffectiveStudyId (in effect):", newEffectiveStudyId)
    console.log("  newInvestigatorId (in effect):", newInvestigatorId)
    console.log("  newEffectiveSiteId (in effect):", newEffectiveSiteId)
    console.log("  user?.userId (in effect):", user?.userId)
    console.log("  user?.siteId (in effect):", user?.siteId) 

    setFormData((prev) => ({
      ...prev,
      study_id: newEffectiveStudyId || "",
      investigator_id: newInvestigatorId || "",
      site_id: newEffectiveSiteId || "", 
    }))
  }, [
    urlStudyId,
    STATE[CurrentStudyState.STUDY]?.id,
    STATE[CurrentStudyState.STUDY]?.investigator_id, 
    STATE[CurrentStudyState.STUDY]?.site_id,
   
  ]) 

  // Gestion du changement d'entrée
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isClosed) {
      console.warn("[PatientInvitation] Blocked submission: study is closed", {
        status: currentStudyFromState?.status,
        study_global_status: currentStudyFromState?.study_global_status,
      })
      alert("This study is closed. Actions are disabled.")
      return
    }
    setIsSubmitting(true)
    setError(null)

    console.log("PatientsInvitationSection - Submitting form with formData:", formData)

    // === Validations ===
  if (!formData.firstName || formData.firstName.length < 3) {
    alert("First name must be at least 3 characters long.")
    setIsSubmitting(false)
    return
  }

  if (!formData.lastName || formData.lastName.length < 3) {
    alert("Last name must be at least 3 characters long.")
    setIsSubmitting(false)
    return
  }

  if (formData.phone && !formData.phone.startsWith("+")) {
    alert("Phone number must start with a '+'.")
    setIsSubmitting(false)
    return
  }


 
    console.log("PatientsInvitationSection - Payload sent to controller:", {
      email: formData.email,
      firstname: formData.firstName,
      lastname: formData.lastName,
      phone_number: formData.phone,
      patient_address_street: formData.street,
      patient_address_number: formData.number,
      patient_address_country: formData.country,
      patient_address_city: formData.city,
      patient_address_postal_code: formData.postalCode,
      study_id: formData.study_id,
      investigator_id: formData.investigator_id, 
      site_id: formData.site_id, 
    })

    if (!formData.study_id) {
      setError("Study ID is missing. Please select a study.")
      setIsSubmitting(false)
      return
    }
    if (!formData.investigator_id) {
      setError("Investigator ID is missing. Please ensure the investigator is associated with this study.")
      setIsSubmitting(false)
      return
    }

    if (!formData.site_id) {
      setError("Site ID is missing. Please ensure the investigator is associated with a site.")
      setIsSubmitting(false)
      return
    }

    try {
      const result = await InvitationController.sendPatient({
        email: formData.email,
        firstname: formData.firstName,
        lastname: formData.lastName,
        phone_number: formData.phone,
        patient_address_street: formData.street,
        patient_address_number: formData.number,
        patient_address_country: formData.country,
        patient_address_city: formData.city,
        patient_address_postal_code: formData.postalCode,
        study_id: formData.study_id,
        investigator_id: formData.investigator_id,
        site_id: formData.site_id, 
      })

      if (result.success) {
        setIsModalOpen(true)
      } else {
        setError(result.message || "Failed to send invitation.")
      }
    } catch (err) {
      console.error("Error sending patient invitation from frontend:", err)
      setError("An unexpected error occurred. Please try again.")
    } finally {
      setIsSubmitting(false)
    }
  }

  // Fermeture du modal et réinitialisation du formulaire
  const handleCloseModal = () => {
    setIsModalOpen(false)
    setFormData((prev) => ({
      ...prev,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      street: "",
      number: "",
      country: "",
      city: "",
      postalCode: "",
    }))
  }

  const onSubmitHandler = isClosed
    ? (e) => {
        e.preventDefault()
        console.warn("[PatientInvitation] onSubmit blocked: study is closed")
        alert("This study is closed. Actions are disabled.")
        return false
      }
    : handleSubmit

  return (
    <div className="bg-dashboard-bg1 p-6 rounded-xl">
      <h2 className="text-xl font-medium mb-6">Patient invitation</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <form onSubmit={onSubmitHandler} className="space-y-4" aria-disabled={isClosed}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                  First name
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="First name"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                  required
                />
              </div>
              <div>
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                  Last Name
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Last name"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                  required
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="name@mail.com"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                  required
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                  Phone number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="+12481237654"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="md:col-span-3">
                <label htmlFor="street" className="block text-sm font-medium text-gray-700 mb-1">
                  Patient address - Street
                </label>
                <input
                  type="text"
                  id="street"
                  name="street"
                  value={formData.street}
                  onChange={handleInputChange}
                  placeholder="Avenue of the sick patient"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                  required
                />
              </div>
              <div>
                <label htmlFor="number" className="block text-sm font-medium text-gray-700 mb-1">
                  Number
                </label>
                <input
                  type="text"
                  id="number"
                  name="number"
                  value={formData.number}
                  onChange={handleInputChange}
                  placeholder="123"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1">
                  Country
                </label>
                <input
                  type="text"
                  id="country"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  placeholder="France"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                  required
                />
              </div>
              <div>
                <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
                  City / Town
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  placeholder="Paris"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                  required
                />
              </div>
              <div>
                <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700 mb-1">
                  Postal code
                </label>
                <input
                  type="text"
                  id="postalCode"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleInputChange}
                  placeholder="75000"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                  required
                />
              </div>
            </div>
            <input type="hidden" name="study_id" value={formData.study_id} />
            <input type="hidden" name="investigator_id" value={formData.investigator_id} />
            <input type="hidden" name="site_id" value={formData.site_id} /> {/* AGGIUNGI QUESTO */}
            <div className="mt-6">
              <Button
                type="submit"
                variant="addbutton"
                className={`px-6 py-2 ${isClosed ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={isSubmitting || isClosed}
                aria-disabled={isSubmitting || isClosed}
                tabIndex={isClosed ? -1 : 0}
              >
                {isSubmitting ? "Sending..." : "Send Invitation"}
              </Button>
            </div>
            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
          </form>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="w-82 h-82 mb-4">
            <img
              src="/logo-circle.png"
              alt="OSHIMED Logo"
              className="w-full h-full object-contain"
              onError={(e) => {
                e.target.onerror = null
                e.target.src = "/img/logo2.png"
              }}
            />
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title="Patient invitation sent"
        primaryAction={handleCloseModal}
        primaryActionLabel="Continue"
        size="xl"
      >
        <div className="space-y-4 text-gray-600">
          <p>The invitation has been successfully sent.</p>
          <p>
            The patient will receive an email with further instructions to review and sign the informed consent form.
          </p>
          <p>Please note that you may need to assist the patient in completing the signature process if necessary.</p>
          <p>You can track their response status in the study dashboard.</p>
        </div>
      </Modal>
    </div>
  )
}